import { Grid } from "@material-ui/core";
import { useEffect, useReducer } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next"
import CustomAlert from "../../componentes/alerts/CustomAlert";
import SearchClearSaveRow from "../../componentes/button/SearchClearSaveRow";
import InputField from "../../componentes/form-fields/InputField/InputField";
import GridInputRow from "../../componentes/form-grids/GridInputRow";
import GridItemContainer from "../../componentes/form-grids/GridItemContainer";
import { DefaultScreenAccordion } from "../../componentes/layouts/components/DefaultScreenAccordion";
import ControlService from "./LabelControlService";
import { DefaultAutocomplete } from '../../componentes/autocomplete/DefaultAutocomplete';
import GridButtonRow from "../../componentes/form-grids/GridButtonRow";
import DefaultButton from "../../componentes/button/DefaultButton";

export const LabelShippingStockLocation = () => {
    const { t } = useTranslation();
    const { control } = useForm();
    const userId = sessionStorage.getItem("userId");

    const initialState = {
        stockLocations: Array(5).fill().map(() => ({
            idStorage: 0,
            idStreet: 0,
            idColumn: 0,
            idLevel: 0,
        })),
        userId: userId,
        cdStatus: 1,
        success: false,
        error: false,
    };

    const reducer = (state, action) => {
        switch (action.type) {
            case 'update':
                return { ...state, ...action.data }
            case "clear":
                return initialState
            case 'success':
                return { ...state, success: true, error: false }
            case 'error':
                return { ...state, success: false, error: true }
            case 'close_alert':
                return { ...state, success: false, error: false }
            default:
                return new Error();
        }
    }

    const [state, dispatch] = useReducer(reducer, initialState);

    const { stockLocations } = state
    const { success, error, ...data } = state

    const handleChange = ({ target: { name, value } }) => {
        dispatch({ type: 'update', data: { [name]: value } }) 
    }
    
    const handleChangeLocation = (index, { target: { name, value } }) => {
        const updatedLocations = [...state.stockLocations];
        updatedLocations[index][name] = value;
        dispatch({ type: "update", data: { stockLocations: updatedLocations } });
    };

    const hasPartialError = (loc) => {
        const algumPreenchido = loc.idStorage || loc.idStreet || loc.idColumn || loc.idLevel;

        if (!algumPreenchido) {
            // linha totalmente em branco = sem erro
            return false;
        }

        // linha parcial = erro se algum campo for 0
        return !(loc.idStorage && loc.idStreet && loc.idColumn && loc.idLevel);
    };

    const canPrint = () => {
        let verify = true;
        
        state.stockLocations.forEach((loc) => {
            // Verifica se algum campo da linha foi preenchido
            const algumPreenchido = loc.idStorage !== 0 || loc.idStreet !== 0 || loc.idColumn !== 0 || loc.idLevel !== 0;

            if (algumPreenchido) {
                // Se algum foi preenchido, todos precisam estar
                if (loc.idStorage === 0 && loc.idStreet === 0 && loc.idColumn === 0 && loc.idLevel === 0) {
                    verify = false;
                }
            }
        });

        if (!verify)
        {
            dispatch({ type: 'error' })
        }
        return verify;
    };


    const handlePrint = () => {
        if (!canPrint())
        {
            return;
        }

        ControlService
            .sendPrintStockLocation(data)
            .then((response) => {
                if (response.status === 200) {
                    dispatch({ type: 'success' })
                }
            })
            .catch((e) => dispatch({ type: 'error' }));
    };

    return (
        <DefaultScreenAccordion
            isTab
            fields={
                <GridItemContainer>
                    <CustomAlert
                        success={success}
                        error={error}
                        handleCloseAlert={() => dispatch({ type: 'close_alert' })}
                    />
                    
                    {state.stockLocations.map((stockLocations, index) => (
                        <GridInputRow>
                            <Grid item xs={12} sm={6} md={4}>
                                <DefaultAutocomplete
                                    name={"idStorage"}
                                    onChange={(e) => handleChangeLocation(index, e)}
                                    placeholder={t("storage")}
                                    label={t("storage")}
                                    useApi
                                    endpoint='GetStorageAutoComplete'
                                    value={stockLocations.idStorage}
                                    defaultSize
                                    error={error && hasPartialError(stockLocations) && stockLocations.idStorage === 0}
                                />
                            </Grid>
                            <Grid item xs={12} sm={3} md={3}>
                                <DefaultAutocomplete
                                        name={"idStreet"}
                                        onChange={(e) => handleChangeLocation(index, e)}
                                        placeholder={t("street")}
                                        label={t("street")}
                                        useApi
                                        endpoint='GetStreetAutoComplete'
                                        value={stockLocations.idStreet}
                                        defaultSize
                                        error={error && hasPartialError(stockLocations) && stockLocations.idStreet === 0}
                                    />
                            </Grid>
                            <Grid item xs={12} sm={3} md={3}>
                                <DefaultAutocomplete
                                        name={"idColumn"}
                                        onChange={(e) => handleChangeLocation(index, e)}
                                        placeholder={t("column")}
                                        label={t("column")}
                                        useApi
                                        endpoint='GetColumnAutoComplete'
                                        value={stockLocations.idColumn}
                                        defaultSize
                                        error={error && hasPartialError(stockLocations) && stockLocations.idColumn === 0}
                                    />
                            </Grid>
                            <Grid item xs={12} sm={4} md={2}>
                                <DefaultAutocomplete
                                        name={"idLevel"}
                                        onChange={(e) => handleChangeLocation(index, e)}
                                        placeholder={t("level")}
                                        label={t("level")}
                                        useApi
                                        endpoint='GetLevelAutoComplete'
                                        value={stockLocations.idLevel}
                                        defaultSize
                                        error={error && hasPartialError(stockLocations) && stockLocations.idLevel === 0}
                                    />
                            </Grid>
                        </GridInputRow>
                    ))}

                    <GridButtonRow>
                        <Grid item xs={4} sm={3} md={2}>
                            <DefaultButton clear className="secondaryButton" onClick={() => dispatch({ type: 'clear' })} />
                        </Grid>
                        <Grid item xs={4} sm={3} md={3}>
                            <DefaultButton labelName={t("sendPrint")} className="primaryButton" onClick={handlePrint} />
                        </Grid>
                    </GridButtonRow>

                </GridItemContainer>
            } />
    );
}